// microscopic section js
document.getElementById("open-popup").onclick = function () {
  document.getElementById("scalp-popup").style.display = "block";
};

document.getElementById("scalp-analysis__close-popup").onclick = function () {
  document.getElementById("scalp-popup").style.display = "none";
};

document.getElementById("open-popup").onclick = function () {
  document.getElementById("scalp-popup").style.display = "flex";
  document.body.style.overflow = "hidden";
};

document.getElementById("scalp-analysis__close-popup").onclick = function () {
  document.getElementById("scalp-popup").style.display = "none";
  document.body.style.overflow = "auto";
};

// microscopic section image src changing code
const mainImage = document.querySelector(
  ".scalp-analysis-popup__main-image img"
);
const originalMainImageSrc = mainImage.getAttribute("src");
const thumbnails = document.querySelectorAll(".popup-slide img");

thumbnails.forEach((thumbnail) => {
  thumbnail.onclick = () => {
    const thumbnailSrc = thumbnail.getAttribute("src");
    mainImage.setAttribute("src", thumbnailSrc);
  };
});

const closePopupBtn = document.getElementById("scalp-analysis__close-popup");
closePopupBtn.onclick = () => {
  document.getElementById("scalp-popup").style.display = "none";
  mainImage.setAttribute("src", originalMainImageSrc);
};

document.getElementById("open-popup").onclick = () => {
  document.getElementById("scalp-popup").style.display = "block";
};

// doctor guidance section slider js
$(document).ready(function () {
  let doctorImages = document.querySelectorAll('.doctor-slider--image');
  if(doctorImages.length > 1){
    function initializeSlick() {
      if (!$(".doctor-slider__container").hasClass("slick-initialized")) {
        $(".doctor-slider__container").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          infinite: true,
          centerMode: false,
          centerPadding: "10px",
        });
      }
    }
  }

  // Initialize on page load
  initializeSlick();

  // Reinitialize on window resize
  $(window).resize(function () {
    initializeSlick();
  });
})
$(document).ready(function () {
  function initializeSlick() {
    if (!$(".pune-page-review__wrapper").hasClass("slick-initialized")) {
      $(".pune-page-review__wrapper").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        centerMode: false,
        centerPadding: "10px",
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    }
  }

  // Initialize on page load
  initializeSlick();

  // Reinitialize on window resize
  $(window).resize(function () {
    initializeSlick();
  });
});
